














































import { defineComponent, reactive, computed, ref } from "@vue/composition-api";
import { QCarousel, QCarouselSlide, QCarouselControl, QBtn } from "quasar";
import { Icon2 } from "@micad/vue-components";
import { Notification } from "@/data/repos/notifications";

export default defineComponent({
  components: {
    QBtn,
    QCarousel,
    QCarouselSlide,
    QCarouselControl,
    Icon2,
  },
  props: {
    notifications: Array as () => Notification[],
  },
  setup(p) {
    const state = reactive({
      slide: "notification-0",
    });

    const length = computed(() => p.notifications?.length || 0);

    const carousel = ref<QCarousel | null>(null);
    const goPrevious = () => carousel.value?.previous();
    const goNext = () => carousel.value?.next();

    return { state, length, carousel, goPrevious, goNext };
  },
});
